export class userModel {
    userId: any | undefined;
    userName: string | undefined;
    friendlyName: string | undefined;
    admin: boolean = false;
    supervisor: boolean = false;
    coordinator: boolean = false;
    staff: boolean = false;
    token: string = '';
    errorMessage: string | undefined;
    isError: boolean = false;   
    role: string = '';
    roleCode: string = '';
}
